/**
 * Isole le message client (bloc `> ...` sous "**Réponse** :") d'une réponse
 * d'agent qui contient aussi des champs internes (Sentiment, Urgence,
 * Catégorie, Escalade, Hypothèses...) — pour ne jamais envoyer ces infos
 * internes au client par mail/SMS.
 *
 * Si le format n'est pas reconnu (agent autre que Mimo — ex. Jojo, qui ne
 * rédige jamais de réponse client, seulement un routage interne), renvoie
 * une chaine vide plutôt que le texte brut : le texte brut est un compte
 * rendu interne (Qui/Motif/Urgence/Oriente vers...), jamais un message
 * présentable à un client. L'appelant doit traiter une chaine vide comme
 * "pas de réponse client disponible" et ne pas proposer d'envoi.
 */
export function extractCustomerReply(text: string): string {
  const lines = text.split("\n");
  // Le libelle exact varie selon le canal ("**Réponse**", "**Réponse (SMS)**",
  // "**Réponse (email)**"...) -- on matche "Réponse" en gras suivi de n'importe
  // quel texte avant la fermeture "**", pas seulement "**Réponse**" exact.
  const idx = lines.findIndex((l) => /\*\*r[ée]ponse\b[^*]*\*\*/i.test(l));
  if (idx === -1) return "";

  // "**Réponse**" est le DERNIER champ du format attendu (voir mimo.md) --
  // tout ce qui suit lui appartient. Le modele utilise generalement une
  // citation Markdown ("> ..."), mais pas toujours de facon parfaitement
  // consistante (variabilite du LLM) -- on accepte donc les lignes avec OU
  // sans "> ", et on ne s'arrete que sur un vrai marqueur de fin : un nouveau
  // champ en gras ("**Sentiment**..."), un titre Markdown ("## Hypothèses",
  // section d'auto-analyse interne que Mimo ajoute parfois hors template --
  // NE DOIT JAMAIS partir au client), ou la fermeture d'un bloc de code.
  const collected: string[] = [];
  for (let i = idx + 1; i < lines.length; i++) {
    const trimmed = lines[i].trim();
    if (trimmed === "```") break;
    if (/^\*\*[^*]+\*\*/.test(trimmed)) break;
    if (/^#{1,6}\s/.test(trimmed)) break;
    collected.push(trimmed.startsWith(">") ? trimmed.replace(/^>\s?/, "") : trimmed);
  }

  while (collected.length && collected[0] === "") collected.shift();
  while (collected.length && collected[collected.length - 1] === "") collected.pop();

  return collected.join("\n").trim();
}
